import { takeEvery, call, put, fork, select } from 'redux-saga/effects'

import { showNotice } from '../../../Layout/Notices/Notices'
import { getLiveId } from '../../../global/blocs/roomInfo'

import { uploadHandout, fetchHandouts, removeHandout } from './api'

export default ({ actionNames, props }) => {
  const { liveToken } = props
  const liveId = getLiveId()

  function* fetchHandoutsListWorker() {
    // we assume that if we do not have access to `state.webinar.role`
    // that you are an audience member.
    const isAudienceMember = yield select((state) => !state.webinar?.role)

    try {
      const { attachments } = yield call(fetchHandouts, liveId, liveToken)

      yield put({ type: actionNames.FETCH_HANDOUTS_SUCCESS, data: attachments })
    } catch (err) {
      yield put({ type: actionNames.FETCH_HANDOUTS_FAILURE })

      // we do not want to display an error notification if the
      // handout feature is failing to load for audience members
      if (!isAudienceMember) {
        showNotice({
          message: 'Unable to list handouts',
          expirationMillis: 5e3,
          isClosable: true,
        })
      }
    }
  }

  function* uploadHandoutsWorker(action) {
    const [data] = action.payload

    try {
      yield call(uploadHandout, liveId, data.file, data.onProgress)
      data.onSuccess()
      yield fork(fetchHandoutsListWorker)
    } catch (err) {
      data.onError(err)
      showNotice({
        message: 'Handout could not be uploaded',
        expirationMillis: 5e3,
        isClosable: true,
      })
    }
  }

  function* removeHandoutWorker(action) {
    const [filename, mode, resolve, reject] = action.payload

    try {
      yield call(removeHandout, liveId, filename)

      if (mode === 'manage') {
        resolve()
      }
    } catch (err) {
      if (mode === 'manage') {
        reject()
      }
      showNotice({
        message: 'Handout could not be removed',
        expirationMillis: 5e3,
        isClosable: true,
      })
    }
  }

  function* watchUpload() {
    yield takeEvery(actionNames.UPLOAD_HANDOUTS, uploadHandoutsWorker)
  }

  function* watchRemove() {
    yield takeEvery(actionNames.REMOVE_HANDOUT, removeHandoutWorker)
  }

  function* watchRealtime() {
    yield takeEvery(actionNames.REALTIME_FILE_UPLOADED, fetchHandoutsListWorker)
  }

  function* init() {
    yield fork(watchUpload)
    yield fork(watchRemove)
    yield fork(watchRealtime)
    yield fork(fetchHandoutsListWorker)
  }

  return {
    default: [init()],
  }
}
